const l = {
  name: "NoThirdParty",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M13,12.9l5.7-5.7l-1.4-1.4L13,10.1l-2.3-2.3L9.3,9.2L13,12.9z"/>
		<path class="st0" d="M30.7,7.2L25,12.9l-3.7-3.7l1.4-1.4l2.3,2.3l4.3-4.3L30.7,7.2z"/>
		<path class="st0" d="M17.7,34.7l2.3-2.3l2.3,2.3l1.4-1.4L21.4,31l2.3-2.3l-1.4-1.4L20,29.6l-2.3-2.3l-1.4,1.4l2.3,2.3l-2.3,2.3
			L17.7,34.7z"/>
		<path class="st0" d="M0,0h40v18H21v4.1c4.5,0.5,8,4.3,8,8.9c0,5-4,9-9,9s-9-4-9-9c0-4.6,3.5-8.4,8-8.9V18H0V0z M2,2v14h36V2H2z
			 M20,24c-3.9,0-7,3.1-7,7s3.1,7,7,7s7-3.1,7-7S23.9,24,20,24z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as NoThirdParty
};
